import { render, staticRenderFns } from "./dashboard-popularity-rank.vue?vue&type=template&id=14a9673b&scoped=true&"
import script from "./dashboard-popularity-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-popularity-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-popularity-rank.vue?vue&type=style&index=0&id=14a9673b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9673b",
  null
  
)

export default component.exports